import { Component, inject, input, output } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faCheck, faEdit, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

import { Passkey } from "../../../_models/passkey.interface";
import { ModalService } from "../../../_services/modal.service";
import { PasskeyDeleteDialogComponent } from "./passkey-delete-dialog.component";

// Liste der Passkeys eines Nutzers, genutzt unter „Mein Konto“ und in der
// Admin-Ansicht des Nutzers (siehe bentomax/hawk#596). Löschen wird vorher
// per Dialog bestätigt, Umbenennen nur, wenn allowRename gesetzt ist.
@Component({
  selector: "hawk-passkey-table",
  standalone: true,
  imports: [DatePipe, FormsModule, FontAwesomeModule],
  templateUrl: "./passkey-table.component.html",
})
export class PasskeyTableComponent {
  passkeys = input.required<Passkey[]>();
  allowRename = input(false);

  renamed = output<{ passkey: Passkey; name: string }>();
  deleteConfirmed = output<Passkey>();

  private modal = inject(ModalService);

  protected editingId: number | null = null;
  protected editName = "";

  protected readonly faCheck = faCheck;
  protected readonly faEdit = faEdit;
  protected readonly faTimes = faTimes;
  protected readonly faTrash = faTrash;

  protected startRename(passkey: Passkey) {
    this.editingId = passkey.id;
    this.editName = passkey.name ?? "";
  }

  protected cancelRename() {
    this.editingId = null;
  }

  protected saveRename(passkey: Passkey) {
    const name = this.editName.trim();
    if (!name) {
      return;
    }
    this.editingId = null;
    if (name !== passkey.name) {
      this.renamed.emit({ passkey, name });
    }
  }

  protected confirmDelete(passkey: Passkey) {
    const ref = this.modal.open(PasskeyDeleteDialogComponent, {
      inputs: { passkey },
      minHeight: "auto",
    });
    ref.closed.subscribe((confirmed) => {
      if (confirmed === true) {
        this.deleteConfirmed.emit(passkey);
      }
    });
  }
}
